module.exports = __webpack_public_path__ + "img/lock_includeText.20a76f44.svg";